<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/intelligent-outbound-call/table">智能外呼</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="姓名"
                        prop="username">
            <el-input placeholder="请输入姓名" clearable
                      v-model="search.username"></el-input>
          </el-form-item>
          <el-form-item label="电话"
                        prop="cellphone">
            <el-input placeholder="请输入电话" clearable
                      v-model="search.cellphone"></el-input>
          </el-form-item>
          <el-form-item label="任务ID"
                        prop="task_id">
            <el-input placeholder="请输入任务ID" clearable
                      v-model="search.call_task_id"></el-input>
          </el-form-item>
          <el-form-item label="外呼结果"
                        prop="status">
            <el-select v-model="search.status" clearable
                       class="width-max">
              <el-option v-for="(label, value) in callStatus"
                         :key="value"
                         :label="label"
                         :value="value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="拨打时间">
            <el-date-picker
                v-model="search['call_record.created_at']"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="center"
                class="width-max"
                clearable>
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15 option-cantor">
        <el-button style="margin-right: 5px;"
                    type="primary"
                    icon="sj-icon-export"
                    @click="onExportSearch"
                    size="small">按搜索结果导出
        </el-button>
        <el-upload class="upload-demo"
                       style="width:100px;"
                       ref="upload"
                       action=""
                       :auto-upload="false"
                       :on-change="query => onUploadFile(query,1)"
                       accept=".xlsx,.xls"
                       :show-file-list="false">
          <el-button icon="sj-icon-add"
                      type="primary"
                      size="small">批量添加
          </el-button>
        </el-upload>
        <el-upload class="upload-demo"
                       style="width:100px"
                       ref="upload"
                       action=""
                       :auto-upload="false"
                       :on-change="query => onUploadFile(query,2)"
                       accept=".xlsx,.xls"
                       :show-file-list="false">
          <el-button icon="sj-icon-add"
                      type="primary"
                      size="small">批量修改
          </el-button>
        </el-upload>
        <el-button type="primary"
                    icon="sj-icon-export"
                    @click="onExportAddDemo"
                    size="small">批量添加Demo
        </el-button>
        <el-button style="margin-left: 5px;"
                    type="primary"
                    icon="sj-icon-export"
                    @click="onExportChangeDemo"
                    size="small">批量修改Demo
        </el-button>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="90">
          <template slot-scope="scope">
            <el-button @click="onShowCustomerInfo(scope.row)" type="text" size="small"> {{scope.row.id}} </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="task_id"
                         label="任务ID"
                         min-width="120"></el-table-column>
        <el-table-column prop="username"
                         label="姓名"
                         min-width="120"></el-table-column>
        <el-table-column prop="cellphone"
                         label="电话"
                         min-width="120"></el-table-column>
        <el-table-column prop="last_called_at"
                         label="拨打时间"
                         min-width="120"></el-table-column>
        <el-table-column prop="status"
                         label="外呼状态"
                         min-width="120">
          <template slot-scope="scope">
            <span>{{callStatus[scope.row.status]}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="110">
          <template slot-scope="scope">
            <div class="button-gutter">
              <router-link :to="`/intelligent-outbound-call/record-table/${scope.row.id}?callTaskId=${$route.params.call_task_id}`">
                <el-button size="mini">外呼记录</el-button>
              </router-link>
              <el-button v-if="scope.row.status === 1" size="mini"
                         @click="onEdit(scope.row)">修改客户信息
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
    <edit-customer-info-dialog :visible.sync="visibleEditDialog" :customer="editCustomer"></edit-customer-info-dialog>
    <customer-info-dialog :visible.sync="visibleInfoDialog" :customer="customerInfo"></customer-info-dialog>
    <upload-error-dialog :visible.sync="visibleErrorDialog" :errorFields="errorFields" :fields="fields"></upload-error-dialog>
  </div>
</template>

<script>
import { searchRules } from '../intelligent-outbound-call.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'
import EditCustomerInfoDialog from '@/views/intelligent-outbound-call/components/EditCustomerInfoDialog'
import CustomerInfoDialog from '@/views/intelligent-outbound-call/components/CustomerInfoDialog'
import UploadErrorDialog from '@/views/intelligent-outbound-call/components/UploadErrorDialog'
// import downloadJS from 'downloadjs'

export default {
  mixins: [table, dateTimePicker],
  components: {
    EditCustomerInfoDialog,
    CustomerInfoDialog,
    UploadErrorDialog,
  },
  data () {
    return {
      searchRules,
      search: {
        id: null,
        task_id: null,
        username: null,
        cellphone: null,
        status: null,
        'call_record.created_at': null,
      },
      visibleEditDialog: false,
      visibleInfoDialog: false,
      visibleErrorDialog: false,
      editCustomer: {},
      customerInfo: {},
      fields: [],
      errorFields: [],
    }
  },
  computed: Vuex.mapState({
    callStatus: state => state.intelligentOutboundCall.callStatus,
  }),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getIntelligentOutboundCallDetailTable', params)
    },
    setTableData ({data}) {
      this.fields = data.data.length > 0 ? Object.keys(data.data[0].variables) : []
      this.$set(this, 'table', data.data)
      this.setPagination(data)
    },
    getexportCallDetailData (params) {
      return request.page('exportCallDetailData', params)
    },
    async onExportSearch () {
      const exportHeader = await this.exportHeader()
      const params = filter.copyJson(this.search)
      params.call_task_id = this.$route.params.call_task_id
      this.$export(this.$route.meta.title, {
        fileHeader: exportHeader,
        total: this.pagination.total,
        request: this.getexportCallDetailData,
        requestParams: params,
        getResponseData: this.handleExportData
      })
    },
    async exportHeader () {
      const data = await this.getexportCallDetailData({per_page: 1})
      const variables = []
      const row = data.data.data[0]
      row.variables && Object.keys(row.variables).forEach(key => {
        variables.push({
          key: key,
          text: key,
        })
        return key
      })
      const collectionInfoList = []
      row.collection_info_list && Object.keys(row.collection_info_list).forEach(key => {
        collectionInfoList.push({
          key: key,
          text: key,
        })
        return key
      })
      return [
        {
          key: 'id',
          text: 'ID',
        },
        {
          key: 'task_id',
          text: '任务ID',
        },
        {
          key: 'username',
          text: '姓名',
        },
        {
          key: 'cellphone',
          text: '电话',
        },
        ...variables,
        {
          key: 'last_called_at',
          text: '拨打时间',
        },
        {
          key: 'call_status',
          text: '外呼状态',
        },
        {
          key: 'intention_list',
          text: '意图收集',
        },
        {
          key: 'record_url',
          text: '录音',
        },
        ...collectionInfoList
      ]
    },
    handleExportData (data) {
      data.data.forEach(item => {
        item.call_status = this.callStatus[item.status]
        item.variables && Object.keys(item.variables).forEach(key => {
          item[key] = item.variables[key]
        })

        item.collection_info_list && Object.keys(item.collection_info_list).forEach(key => {
          item[key] = item.collection_info_list[key]
        })
      })
      console.log(data)
      return data
    },
    onEdit (row) {
      this.editCustomer = filter.copyJson(row)
      this.visibleEditDialog = true
    },
    onShowCustomerInfo (row) {
      this.customerInfo = row
      this.visibleInfoDialog = true
    },
    onUploadFile (file, type) {
      let isLt10M = file.raw.size / 1024 / 1024 < 5
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        this.$refs.upload.clearFiles()
        return false
      }

      let formData = new FormData()
      formData.append('file', file.raw)
      formData.append('call_task_id', this.$route.params.call_task_id)
      if (type === 1) {
        this.batchUploadCreateCallDetail(formData)
      } else if (type === 2) {
        this.batchUploadUpdateCallDetail(formData)
      }
    },
    batchUploadCreateCallDetail (formData) {
      request.loading('importCallDetailAdd', formData).then(_ => {
        this.$message.success('上传成功')
      }).catch(this.catchUploadFile)
    },
    batchUploadUpdateCallDetail (formData) {
      request.loading('importCallDetailChange', formData).then(_ => {
        this.$message.success('上传成功')
      }).catch(this.catchUploadFile)
    },
    catchUploadFile (error) {
      if (error.response.data.ret === 212001) {
        this.visibleErrorDialog = true
        this.errorFields = error.response.data.detail
      }
    },
    dowloadAudio (row) {
      const downloadFile = document.createElement('a')
      document.body.append(downloadFile)
      downloadFile.href = row.record_url
      downloadFile.rel = 'noopener noreferrer'
      downloadFile.click()
      document.body.removeChild(downloadFile)
    },
    onExportAddDemo () {
      request.common('robotcallSetting').then(({data}) => {
        window.location.href = data.demo_file_add_calldetail
      })
    },
    onExportChangeDemo () {
      request.common('robotcallSetting').then(({data}) => {
        window.location.href = data.demo_file_update_calldetail
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.option-cantor {
  display: flex;
  align-items: center;;
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/intelligent-outbound-call/pages/IntelligentOutboundCallDetailTable.vue